import moment from 'moment-timezone';

export default () => {
	let months = moment.months();
	return months.map(month => ({
		value: month,
		label: month,
	}));
};
